import { useTenantData } from '@dev-agents/tenant-context';
import { useEffect, useRef } from 'react';
import { Redirect } from 'react-resource-router';

import { useRovoDevWebAnalyticsClient } from '../../controllers/rovo-dev-web-analytics-events';
import { useAuthData } from '../../utils/auth-context';
import { useUserPermData } from '../../utils/user-perm-context';

export const RootPage = () => {
	const { tenantContexts } = useTenantData();
	const { user } = useAuthData();
	const { cloudId, orgId } = tenantContexts[0];
	const hasFiredScreenEvent = useRef(false);
	const { rovoDevAgentsUser } = useUserPermData();
	const { fireScreenEvent } = useRovoDevWebAnalyticsClient();

	useEffect(() => {
		if (cloudId && user?.accountId && !hasFiredScreenEvent.current) {
			fireScreenEvent({
				name: 'devAgentsHomePage',
				attributes: {
					productInstalled: rovoDevAgentsUser.userSiteHasActiveDevAiEntitlement,
				},
			});
			hasFiredScreenEvent.current = true;
		}
	}, [
		cloudId,
		user?.accountId,
		rovoDevAgentsUser.isAdmin,
		rovoDevAgentsUser.userSiteHasActiveDevAiEntitlement,
		orgId,
		fireScreenEvent,
	]);

	if (!rovoDevAgentsUser.userSiteHasActiveDevAiEntitlement) {
		return <Redirect to="/no-access" />;
	}

	return <Redirect to="/home" />;
};
